import { createSelector } from '@reduxjs/toolkit';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { getTimezone } from 'reducers/utils';
import { transformRawDistresses } from 'utils/DataTransform/Distress/DistressList';
import dayjs from 'dayjs';
import { selectors as filtersSelectors } from 'containers/Pages/Tasks/Emergencies/Modules/filters';
import { transformDistressDetails } from 'utils/DataTransform/Distress/DistressDetails';
import { PAGE_URLS } from 'utils/constants';
import { DISTRESS_RESPONSE_STATUS } from 'utils/constants/distressStatus';
import isEmpty from 'lodash/isEmpty';

export const getEmergencyListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getTimezone,
  (list, timezone) => {
    if (!list) return [];
    const current = dayjs();
    const results = transformRawDistresses({ list, current, timezone });
    return results;
  },
);

export const getTotalEntries = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => {
    if (!rowsCount) {
      return 0;
    }
    return rowsCount;
  },
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);

export const getEmergencyFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);
export const getEmergencyDetailTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getTimezone,
  (details, timeZone) => {
    if (!details || Object.keys(details).length === 0) {
      return {};
    } //should never happen
    const current = dayjs();
    return transformDistressDetails({ details, current, timeZone });
  },
);
export const getEmergencyDetailRaw = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (isEmpty(details)) {
      return {};
    }
    return details;
  },
);
export const getEmergencyStatus = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  details => {
    if (!details || Object.keys(details).length === 0) {
      return false;
    }
    const isResolved =
      details.currentStatus === DISTRESS_RESPONSE_STATUS.RESOLVED.id;
    const isNotResolved =
      details.currentStatus === DISTRESS_RESPONSE_STATUS.RESOLVED_ABORTED.id;
    return !(isResolved || isNotResolved);
  },
);

export const getEmergencyListNotification = createSelector(
  dataGridTableSelectors.getGridTableList,
  getTimezone,
  (list, timezone) => {
    if (!list) return [];
    const current = dayjs();
    const results = transformRawDistresses({ list, current, timezone });
    return results.map(eme => ({
      type: PAGE_URLS.EMERGENCIES.name,
      user: {
        name: eme.distressee_name,
        image: '',
      },
      title: 'Emergency',
      content: eme.status,
      read: false,
    }));
  },
);
